import React from "react";
import { Timeline, Typography } from "antd";
import { useTranslation } from "react-i18next";
import type { AuditEvent } from "../types";

type Props = {
  events: AuditEvent[];
};

export function AuditTrailPanel({ events }: Props) {
  const { t } = useTranslation();
  if (!events.length) {
    return <Typography.Text type="secondary">{t("compliance.audit.empty")}</Typography.Text>;
  }
  return (
    <Timeline
      items={events.map((e) => ({
        children: (
          <div>
            <Typography.Text strong>
              {t(`compliance.audit.actions.${e.action}`, { defaultValue: e.action })}
            </Typography.Text>
            <br />
            <Typography.Text type="secondary">
              {e.actor_label || e.actor_user_id} · {new Date(e.created_at).toLocaleString()}
              {e.detail ? ` — ${e.detail}` : ""}
            </Typography.Text>
          </div>
        ),
      }))}
    />
  );
}
